<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Kullanıcı Düzenle <small>( {{ first_name }} {{ last_name }} )</small></h3>
            </div>
            <div class="row">

               <div class="col-md-6">
                <div class="form-group">
                  <label for="university">Üniversite</label>
                  <select class="form-control custom-input" v-model="university">
                    <option v-for="university in universities" :key="university.id" :value="university.id" >{{ university.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="dorm">Yurt</label>
                  <router-link :to="{ name: 'dorms.update', params: {id: dorm.id} }" class=""> Goruntule</router-link>
                  <v-select v-model="dorm" label="name" :options="dorms" @search="searchDorms">
                    <template slot="no-options">
                      Lütfen aramak istediğiniz yurdu yazın..
                    </template>
                  </v-select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="is_active">Onay Durumu</label>
                  <select class="form-control custom-input" v-model="is_active">
                    <option :value="1">Aktif</option>
                    <option :value="0">Pasif</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="type">Üye Tipi</label>
                  <select class="form-control custom-input" v-model="type">
                    <option value selected disabled>Seçiniz...</option>
                    <option value="1">Yurt</option>
                    <option value="2">Öğrenci</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="first_name">Ad</label>
                  <input
                    type="text"
                    v-model="first_name"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="last_name">Soyad</label>
                  <input
                    type="text"
                    v-model="last_name"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-posta</label>
                  <input type="text" v-model="email" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="password">Şifre</label>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control custom-input"
                    placeholder
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="phone">Telefon</label>
                  <input type="text" v-model="phone" class="form-control custom-input" placeholder>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <error :errors="validationErrors" v-if="validationErrors"></error>
                  <button class="btn btn-success pull-right" @click="updateData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import vSelect from 'vue-select'
  import Error from "@/components/layouts/Error";

  export default {
    components: { vSelect, Error },
  data() {
    return {
      validationErrors: "",
      api: "users/",
      id: this.$route.params.id,
      is_active: "",
      type: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: '',
      university: "",
      universities: [],
      dorm: "",
      dorms: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchDorms (search, loading) {
      loading(true);
      this.fetchDorms(loading, search, this);
    },
    fetchDorms: _.debounce((loading, search, vm) => {
      vm.axios.get('dorms?name=' + search).then(response => {
        vm.dorms = response.data.data.data;
        loading(false);
      });
    }, 350),
    getData() {
      this.axios.get(this.api + this.id + "/edit").then(response => {
        this.type = response.data.user.type_id;
        this.first_name = response.data.user.first_name;
        this.last_name = response.data.user.last_name;
        this.email = response.data.user.email;
        this.phone = response.data.user.phone;
        this.university = response.data.user.university_id;
        this.is_active = response.data.user.is_active;
        this.universities = response.data.universities;
        if (response.data.user.dorm_id) {
          this.axios.get('dorms/'+ response.data.user.dorm_id).then(response => {
            this.dorm = response.data.dorm;
          });
        }
      });
    },
    updateData() {
      this.validationErrors = "";
      this.$Progress.start();
      this.axios.put(this.api + this.id, {
        is_active: this.is_active,
        type: this.type,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: this.password,
        phone: this.phone,
        dorm_id: this.dorm.id,
        university: this.university
        // eslint-disable-next-line no-unused-vars
      }).then(response => {
        this.$Progress.finish();
        this.$swal.fire({
          position: 'top-end',
          type: 'success',
          title: 'İşlem başarılı!',
          showConfirmButton: false,
          timer: 1500
        });
      }).catch(error => {
        this.$Progress.finish();
        this.$swal.fire({
          position: 'top-end',
          type: 'error',
          title: 'İşlem başarısız!',
          showConfirmButton: false,
          timer: 1500
        });
        if (error.response.status == 422) {
          this.validationErrors = error.response.data.errors;
        }else if ( error.response.status == 500 ) {
          this.validationErrors = { message : ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!'] };
        }
      })
    }
  }
};
</script>

<style scoped>
  .v-select {
    padding-bottom: 14px;
  }
</style>
